"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Configuration = exports.decodeConfiguration = exports.ConfigurationTypeToString = exports.ConfigurationType = void 0;

var configuration_1 = require("./http/configuration");

var ConfigurationType;

(function (ConfigurationType) {
  ConfigurationType[ConfigurationType["Full"] = 0] = "Full";
  ConfigurationType[ConfigurationType["Logging"] = 1] = "Logging";
  ConfigurationType[ConfigurationType["Resources"] = 2] = "Resources";
  ConfigurationType[ConfigurationType["System"] = 3] = "System";
  ConfigurationType[ConfigurationType["Connection"] = 4] = "Connection";
  ConfigurationType[ConfigurationType["Metadata"] = 5] = "Metadata";
  ConfigurationType[ConfigurationType["Automation"] = 6] = "Automation";
})(ConfigurationType = exports.ConfigurationType || (exports.ConfigurationType = {}));

exports.ConfigurationTypeToString = function (t) {
  if (t === ConfigurationType.Full) {
    return "Full system configuration";
  }

  if (t === ConfigurationType.Logging) {
    return "Logging configuration (PLM)";
  }

  if (t === ConfigurationType.Resources) {
    return "Resource definition configuration (Portman)";
  }

  if (t === ConfigurationType.System) {
    return "System monitoring configuration";
  }

  if (t === ConfigurationType.Connection) {
    return "Connectivity configuration";
  }

  if (t === ConfigurationType.Automation) {
    return "Automation configuration (plmjson)";
  }

  return "Metadata configuration";
};

function decodeConfiguration(c) {
  return new Configuration(c.id, c.type, c.configuration, c.filename, new Date(c.time));
}

exports.decodeConfiguration = decodeConfiguration;

var Configuration =
/** @class */
function () {
  function Configuration(id, type, configuration, filename, time) {
    this.id = id;
    this.type = type;
    this.configuration = configuration;
    this.filename = filename;
    this.time = time;
    this.associations = [];
  }

  Configuration.prototype.get = function (credentials) {
    var _this = this;

    return configuration_1.get(this.id, credentials).then(function (ret) {
      _this.type = ret.type;
      _this.configuration = ret.configuration;
      _this.filename = ret.filename;
      _this.time = new Date(ret.time);

      if (ret.associations != null) {
        _this.associations = ret.associations;
      } else {
        _this.associations = [];
      }

      return _this;
    });
  };

  Configuration.prototype.store = function (credentials) {
    var _this = this;

    return configuration_1.create(this, credentials).then(function (ret) {
      _this.id = ret.id;
      _this.time = new Date(ret.time);
      return _this;
    });
  };

  return Configuration;
}();

exports.Configuration = Configuration;